var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-workflow',[_c('app-icon',{attrs:{"classes":"mt-4 ml-4"},on:{"click":function($event){return _vm.back()}}},[_vm._v("arrow_back")]),_c('manage-trial-notification-preferences')],1)}
var staticRenderFns = []

export { render, staticRenderFns }